<template>
  <div>
    <h1>Easy table</h1>

    <input type="text" class="form-control" placeholder="" v-model="filterWord">
    <ve-table ref="tableRef"  row-key-field-name="SystemId"
              :columns="gridData.columns"
              :table-data="tableData"
              :sort-option="sortOption"
              :expand-option="expandOption"
              :radio-option="radioOption"
              :checkbox-option="checkboxOption"
              :row-style-option="rowStyleOption"
              :cell-style-option="cellStyleOption"
              :editOption="editOption"
              :cellSelectionOption="cellSelectionOption"
               fixed-header
               border-y
    />


    {{selectedRowKeys}}

    <a role="button" class="btn btn-primary" @click="btnTest">Test</a>
    <a role="button" class="btn btn-primary" @click="btnTest2">Test2</a>
    <a role="button" class="btn btn-primary" @click="btnTest3">Test3</a>
  </div>
</template>

<script>/**
 columns
 { field: "name", key: "a", title: "Name", align: "center" },

 field: "material",
 title: "物料",
 width: 50,
 titleAlign: "center",
 columnAlign: "center",
 isFrozen: true,
 isResize: true


 fixed: "left" / "",
 type: "radio",
 type: "checkbox",
 type: "expand",      //出現一個  >  可以展開detail


 radio
 field: "radio",
 key: "radio",
 title: "",
 width: 100,
 fixed: this.enableColumnFixed ? "left" : "",
 type: "radio",

 field: "checkbox",
 key: "checkbox",
 title: "",
 width: 100,
 fixed: this.enableColumnFixed ? "left" : "",
 type: "checkbox",

 sortBy: "asc",

 edit: true,

 圖示欄位(性別)
 renderBodyCell: ({ row, column, rowIndex }, h) => {
                                const cellData = row[column.field];
                                let iconName =
                                    cellData === 1
                                        ? "icon-male"
                                        : "icon-female";
                                return (
                                    <i
                                        style="font-size:20px;color:#666;"
                                        class={"demo-sex iconfont " + iconName}
                                    />
                                );
                            },

 文字變色欄位 (status)
 renderBodyCell: ({ row, column, rowIndex }, h) => {
                        const cellData = row[column.field];
                        const STATUS = [
                            {
                                name: "Working",
                                color: "#48a4ef",
                            },
                            {
                                name: "Meeting",
                                color: "#d8899c",
                            },
                            { name: "Traveling", color: "#a88cd9" },
                        ];
                        const state = STATUS[cellData];
                        return (
                            <span
                                class="status-span"
                                style={"color:" + state.color}
                            >
                                {state.name}
                            </span>
                        );
                    },

 Tag欄位
 renderBodyCell: (
 { row, column, rowIndex },
 h,
 ) => {
                                        const cellData = row[column.field];
                                        const LANGS = [
                                            {
                                                name: "Javascript",
                                                color: "#48a4ef",
                                            },
                                            {
                                                name: "Python",
                                                color: "#d8899c",
                                            },
                                            { name: "java", color: "#a88cd9" },
];
const skills = LANGS.slice(0, cellData);
return skills.map((skill) => {
  return (
      <span
          class="skill-span"
          style={
              "background-color:" +
              skill.color
          }
      >
                                                    {skill.name}
                                                </span>
  );
});
},

 進度條欄位
 renderBodyCell: (
 { row, column, rowIndex },
 h,
 ) => {
                                        const cellData = row[column.field];
                                        const colorClass =
                                            cellData > 60
                                                ? "demo-blue"
                                                : cellData > 30
                                                ? "demo-orange"
                                                : "demo-red";
                                        return (
                                            <div class="proficiency-span-container">
                                                <span
                                                    class={
                                                        "proficiency-span " +
                                                        colorClass
                                                    }
                                                    style={
                                                        "width:" +
                                                        cellData +
                                                        "%;"
                                                    }
                                                >
                                                    {cellData}%
                                                </span>
                                            </div>
                                        );
                                    },


 篩選，類似excel進階篩選
 filter: {
                        filterList: [
                            { value: 0, label: "Working", selected: false },
                            { value: 1, label: "Metting", selected: false },
                            { value: 2, label: "Traveling", selected: false },
                        ],
                        isMultiple: true,
                        // filter confirm hook
                        filterConfirm: (filterList) => {
                            const values = filterList
                                .filter((x) => x.selected)
                                .map((x) => x.value);
                            this.searchByNameField(values);
                        },
                        // filter reset hook
                        filterReset: (filterList) => {
                            this.searchByNameField([]);
                        },
                        // max height
                        //maxHeight: 120
                    },

 **/
import _ from "lodash";

export default {
  //name: "TEst",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      tableData:[],
      filterWord:"",
      filterDatasOrg:null,
      selectedRowKeys:[],
      rowStyleOption: {
        stripe: true,
      },
      sortOption: {
        sortAlways: true,
        sortChange: (params) => {
          this.sortChange(params);
        },
      },
      // sort change
      sortChange(params) {// eslint-disable-line
        let that=this;
        Object.entries(params).forEach(([key, value]) => {
          if (value){
            // that.gridData.datas=o=> Object.keys(key).sort().reduce((r, k) => (r[k] = o[k], r), {})
            // that.gridData.datas=arrayUtil.SortByObjectProperty(that.gridData.datas,key);
            that.gridData.datas = _.orderBy(that.gridData.datas, [key],[value]);
          }
        });

        // const sortFileld1 = "sex";
        // const sortFileld2 = "proficiency";
        // if (params[sortFileld1] || params[sortFileld2]) {
        //   this.tableData.sort((a, b) => {
        //     if (params[sortFileld1]) {
        //       if (params[sortFileld1] === "asc") {
        //         return a[sortFileld1] - b[sortFileld1];
        //       } else if (params[sortFileld1] === "desc") {
        //         return b[sortFileld1] - a[sortFileld1];
        //       }
        //     } else if (params[sortFileld2]) {
        //       if (params[sortFileld2] === "asc") {
        //         return a[sortFileld2] - b[sortFileld2];
        //       } else if (params[sortFileld2] === "desc") {
        //         return b[sortFileld2] - a[sortFileld2];
        //       }
        //     }
        //   });
        // } else {
        //   this.resetTableData();
        // }
        // // scroll to top
        // this.$refs["tableRef"].scrollTo({ top: 0 });
      },
      // resetTableData() {
      //   this.tableData = this.sourceData.slice(0);
      //   this.filter();
      // },
      radioOption: {
        selectedRowChange: ({ row }) => { // eslint-disable-line
          this.selectedRowKeys= row["SystemId"];
        },
      },
      checkboxOption: {
        // row select change event
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {  // eslint-disable-line
          //console.log(row, isSelected, selectedRowKeys);
          this.selectedRowKeys= selectedRowKeys;
          //
        },
        // selected all change event
        selectedAllChange: ({ isSelected, selectedRowKeys }) => { // eslint-disable-line
          //console.log(isSelected, selectedRowKeys);
          this.selectedRowKeys= selectedRowKeys;

        },
      },
      expandOption: {
        render: ({ row, column, rowIndex }, h) => { // eslint-disable-line
          // return (
          //     <p>
          //       Hello everyone, My name is{" "}
          //       <span style="font-weight:bold;">{row.name}</span>,
          //       I'm a {row.profession}. And I'm living in{" "}
          //       {row.address}.
          //     </p>
          // );
        },
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => { // eslint-disable-line
          if (column.field === "proficiency") {
            return "table-body-cell-proficiency";
          }
        },
      },
      editOption: {
        // cell value change
        cellValueChange: ({ row, column }) => {
          console.log("cellValueChange row::", row);
          console.log("cellValueChange column::", column);
        },
      },
      cellSelectionOption: {
        // disble cell selection
        enable: false,
      },
      renderRowIndex({ row, column, rowIndex }) {// eslint-disable-line
        return rowIndex  + 1;
        //js x
        // return <span>{rowIndex + this.startRowIndex + 1}</span>;
      },
      gridData:{
        columns: [
          { field: "radio", key: "radio", title: "",  width:100,fixed:"left",type: "radio"},
          { field: "checkbox", key: "checkbox", title: "", width:100, fixed:"left",type: "checkbox"},
          { field: "f", key: "fzz", title: "功能", align: "center" , renderBodyCell:  this.renderFunctionButton},
          { field: "name", key: "a", title: "Name", align: "center" ,sortBy:""},
          { field: "date", key: "b", title: "Date", align: "left",sortBy:"" },
          { field: "hobby", key: "c", title: "Hobby", align: "right" ,sortBy:"" },
          { field: "address", key: "d", title: "Address" ,sortBy:"" },
        ],
        datas: [
          {
            SystemId: "John",
            name: "John",
            date: "1900-05-20",
            hobby: "coding and coding repeat",
            address: "No.1 Century Avenue, Shanghai",
          },
          {
            SystemId: "Dickerson",
            name: "Dickerson",
            date: "1910-06-20",
            hobby: "coding and coding repeat",
            address: "No.1 Century Avenue, Beijing",
          },
          {
            SystemId: "Larsen",
            name: "Larsen",
            date: "2000-07-20",
            hobby: "coding and coding repeat",
            address: "No.1 Century Avenue, Chongqing",
          },
          {
            SystemId: "Geneva",
            name: "Geneva",
            date: "2010-08-20",
            hobby: "coding and coding repeat",
            address: "No.1 Century Avenue, Xiamen",
          },
          {
            SystemId: "Jami",
            name: "Jami",
            date: "2020-09-20",
            hobby: "coding and coding repeat",
            address: "No.1 Century Avenue, Shenzhen",
          },
        ],
      }
    };
  },
  methods: {
    async loadData() {
      this.addColunmSeq();
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    addColunmSeq() {
      this.gridData.columns.unshift({
        field: "rowIndex",
        key: "rowIndex",
        title: "#",
        width: 100,
        fixed: "left" ,
        renderBodyCell: this.renderRowIndex,
      });
    },
    resetTableData() {
      this.tableData = this.gridData.datas.slice(0);
      this.tableData.pop();
      this.tableData = this.gridData.datas.slice(0);
    },
    btnTest2(){
      // this.gridData.datas=[];
      this.resetTableData();
    },
    btnTest3(){
      // this.gridData.datas=[];
      this.tableData.pop();
    },
    btnTest(){
      //this.$refs["tableRef"].startEditingCell({ rowKey, colKey, defaultValue });
      // this.$refs["tableRef"].scrollTo({ top: 0 });
      //this.$refs["tableRef"].scrollToRowKey({ rowKey: rowKey });
      //this.$refs["tableRef"].setHighlightRow({ rowKey: rowKey });

      let that=this;
      // let arrayTmp = _.pickBy(this.gridData.datas, function(value, key) {  // eslint-disable-line
      //   return _.includes(value, that.filterWord);
      // });

      // let arrayTmp = _.filter(this.gridData.datas, function(item) {
      //   return _.contains(values, item[property]);
      // });


      if (that.filterWord){
        // var arrayTmp = _.pickBy(this.gridData.datas, function(value, key) {
        //   // return _.startsWith(key, that.filterWord);
        //
        //   Object.keys(value).forEach(key => {
        //     if(value[key].includes(that.filterWord))
        //       return true;
        //   })
        //   return false;
        // });

        let arrayTmp=[];
        this.gridData.datas.forEach((item)=>{
          Object.keys(item).forEach(key => {
            if(item[key].includes(that.filterWord))
              arrayTmp.push(item)
          })
        })

        console.log(arrayTmp );

        // this.gridData.datas=arrayTmp;
        // this.gridData.datas=[];

        this.tableData=arrayTmp;

      }else{
        this.resetTableData();
      }
    },
    renderFunctionButton({ row, column, rowIndex },h) {  // eslint-disable-line
      // const cellData = row[column.field];
      // let iconName =
      //     cellData === 1
      //         ? "icon-male"
      //         : "icon-female";

      //Textbox
      // const text = row[column.field];
      // return <input style="width:100%" value={text}></input>;

      //link
      // const text = row[column.field];
      // return (
      //     <span>
      //                               <a
      //                                   class="test-text"
      //                                   href="http://github.com"
      //                                   style="color:#1890ff;cursor:pointer;"
      //                               >
      //                                   {text}
      //                               </a>
      //       &nbsp;are my hobbies
      //                           </span>
      // );
      //button
      return (
          <a role="button" class="btn btn-primary" on-click={() => this.editRow(rowIndex)}>送出</a>

      );
    },

    editRow(rowIndex){
      alert('hi' +rowIndex)
    }
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>

</style>
